export default class AlRsvpSelectorController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.scopedGuestlists = [];
        this.onRsvpSelect = () => {
        };
        this.onGuestlistSelect = () => {
        };

        this.models = {
            rsvp_id: null,
            guestlist_id: null
        };

        this.disabledStates = {
            guestlists: true,
            rsvps: true
        }

        this.disabledStates = {
            guestlists: true,
            rsvps: true
        }

        this.items = {
            guestlists: [],
            rsvps: []
        }

        this._initSelectizeOptions();
    }

    $onInit() {
        this._loadGuestlists();

        this._initWatchers();
    }

    handleGuestlistChange(value) {
        if (!value) {
            this.models.guestlist_id = _.get(_.first(this.items.guestlists), 'value', null);
        } else {
            this.models.guestlist_id = _.cloneDeep(value);
        }

        this.onGuestlistSelect({
            guestlistId: this.models.guestlist_id ? parseInt(this.models.guestlist_id) : null
        });
        this.scope.$applyAsync();
    }

    handleRsvpChange(value) {
        if (!value) {
            this.models.rsvp_id = _.get(_.first(this.items.rsvps), 'value', null);
        } else {
            this.models.rsvp_id = _.cloneDeep(value);
        }

        this.onRsvpSelect({
            rsvpId: this.models.rsvp_id ? parseInt(this.models.rsvp_id) : null
        });
        this.scope.$applyAsync();
    }

    _initSelectizeOptions() {
        this.selectizeOptions = {
            rsvps: {
                maxItems: 1,
                placeholder: this.translate.instant('general.verbs.loading') + '...'
            },
            guestlists: {
                maxItems: 1,
                placeholder: this.translate.instant('general.verbs.loading') + '...'
            }
        }
    }

    _loadGuestlists() {
        const filters = [];
        if (this.scopedGuestlists) {
            filters.push({
                field: 'id',
                operator: 'in',
                value: this.scopedGuestlists
            })
        }

        this.api
            .post(`fp/guestlists`, {
                sort: {
                    name: 'asc'
                },
                filters,
                pagination: {
                    perPage: -1
                },
                fields: [
                    'name',
                    'id'
                ]
            })
            .then(({data}) => {
                this.items.guestlists = _.map(data.data, (guestlist) => ({
                    value: guestlist.id,
                    label: guestlist.name
                }));
                this.models.guestlist_id = _.get(_.first(data.data), 'id', null);

                this.disabledStates.guestlists = false;

                this.scope.$applyAsync();
            })
    }

    _loadRsvps() {
        this.disabledStates.rsvps = true;
        this.items.rsvps = [];
        this.models.rsvp_id = null;

        if (!this.models.guestlist_id) {
            return;
        }

        const rsvpsStore = this.injector.get('Rsvps')
            .create('AlRsvpSelectorRsvpsStore')
            .reset({
                listview: 'AlRsvpSelectorRsvpsStore',
                persist: false,
                columns: [
                    {
                        key: 'id',
                        type: 'integer',
                        visible: true
                    },
                    {
                        key: 'contact.full_name',
                        type: 'string',
                        visible: true
                    },
                    {
                        key: 'code',
                        type: 'string',
                        visible: true
                    },
                    {
                        key: 'guestlist.id',
                        type: 'integer',
                        visible: true
                    }
                ],
                permanentFilters: {
                    'guestlist.id': this.models.guestlist_id
                },
                pagination: {
                    perPage: -1
                }
            });

        rsvpsStore.dispatch('getData')
            .then(() => {
                this.items.rsvps = _.map(rsvpsStore.state.data, (rsvp) => ({
                    value: rsvp.id,
                    label: `${rsvp.contact.full_name} (${rsvp.code})`
                }));
                this.models.rsvp_id = _.get(_.first(rsvpsStore.state.data), 'id', null);

                this.disabledStates.rsvps = false;

                this.scope.$applyAsync();
            })
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.models.guestlist_id,
            () => {
                this._loadRsvps();
            }
        )
    }
}

AlRsvpSelectorController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/rsvps/components/al-rsvp-selector/controller.js